// Announcement bar — rotate messages on mobile
(function () {
  document.querySelectorAll('[data-announcement-mobile]').forEach(function (host) {
    const msgs = host.querySelectorAll('[data-announcement-msg]');
    if (msgs.length <= 1) return;
    let i = 0;
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, 3500);
  });
})();

(function () {
  const drawer = document.querySelector('[data-mobile-drawer]');
  const toggle = document.querySelector('[data-mobile-toggle]');
  if (toggle && drawer) {
    toggle.addEventListener('click', function () {
      drawer.classList.toggle('is-open');
      document.body.style.overflow = drawer.classList.contains('is-open') ? 'hidden' : '';
    });
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        drawer.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
  }
})();

// Footer newsletter — show Subscribe button elegantly when typing
(function () {
  document.querySelectorAll('[data-newsletter-form]').forEach(function (form) {
    const input = form.querySelector('[data-newsletter-input]');
    if (!input) return;
    const update = function () {
      form.classList.toggle('has-value', input.value.trim().length > 0);
    };
    input.addEventListener('input', update);
    update();
  });
})();

// Contact FAQ — mobile-only accordion (only one item open at a time)
(function () {
  function setup() {
    if (window.innerWidth >= 768) return;
    document.querySelectorAll('[data-contact-faq]').forEach(function (host) {
      const items = host.querySelectorAll('[data-cf-item]');
      // Ensure only first is open initially on mobile
      items.forEach(function (it, i) {
        if (i === 0) it.classList.add('is-open');
        else it.classList.remove('is-open');
      });
      items.forEach(function (item) {
        const btn = item.querySelector('[data-cf-toggle]');
        if (!btn || btn.dataset.bound) return;
        btn.dataset.bound = '1';
        btn.addEventListener('click', function () {
          const willOpen = !item.classList.contains('is-open');
          items.forEach(function (i) { i.classList.remove('is-open'); });
          if (willOpen) item.classList.add('is-open');
        });
      });
    });
  }
  setup();
  window.addEventListener('resize', setup);
})();

// FAQ accordion — toggle is-open class on items. Supports multiple toggle buttons per item.
(function () {
  document.querySelectorAll('[data-faq-item]').forEach(function (item) {
    const btns = item.querySelectorAll('[data-faq-toggle]');
    if (!btns.length) return;
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const isOpen = item.classList.toggle('is-open');
        btns.forEach(function (b) {
          b.setAttribute('aria-expanded', String(isOpen));
        });
      });
    });
  });
})();

// Reviews marquee — slow continuous scroll; pauses on hover (CSS) or tap (mobile)
(function () {
  var coarse = window.matchMedia && window.matchMedia('(hover: none)').matches;
  document.querySelectorAll('.wosh-reviews').forEach(function (root) {
    var viewport = root.querySelector('[data-reviews-viewport]');
    if (!viewport) return;
    // On touch / non-hover devices a tap toggles the pause (desktop uses :hover).
    if (coarse) {
      viewport.addEventListener('click', function () {
        root.classList.toggle('is-paused');
      });
    }
  });
})();

/* ─── Product page interactions ─── */
(function () {
  // Thumbnail toggling — swaps main image when data-img is present
  document.querySelectorAll('[data-pdp-thumbs]').forEach(function (group) {
    var thumbs = group.querySelectorAll('[data-pdp-thumb]');
    var section = group.closest('.wosh-pdp');
    var mainImg = section ? section.querySelector('[data-pdp-main]') : null;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        var src = t.getAttribute('data-img');
        if (mainImg && src) mainImg.setAttribute('src', src);
      });
    });
  });

  // Scent toggling
  document.querySelectorAll('[data-scent]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var parent = btn.closest('.wosh-pdp__scents');
      if (!parent) return;
      parent.querySelectorAll('[data-scent]').forEach(function (x) { x.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

  // Size toggling + live price update
  document.querySelectorAll('[data-kaching-bundle]').forEach(function (group) {
    var sizes = group.querySelectorAll('[data-variant-id]');
    var section = group.closest('.wosh-pdp') || document;
    var variantsScript = section.querySelector('[data-pdp-variants]');
    var variants = [];
    try { variants = variantsScript ? JSON.parse(variantsScript.textContent) : []; } catch (_) {}

    function updateUi(variantId) {
      var v = variants.find(function (x) { return String(x.id) === String(variantId); });
      if (!v) return;
      var priceEl = section.querySelector('[data-pdp-price]');
      var perWashEl = section.querySelector('[data-pdp-per-wash]');
      var memberEl = section.querySelector('[data-pdp-member-per-wash]');
      var atcPriceEl = section.querySelector('[data-pdp-atc-price]');
      if (priceEl) priceEl.textContent = v.price;
      if (perWashEl) perWashEl.textContent = v.per_wash + '/wash';
      if (memberEl) memberEl.textContent = v.member_per_wash + '/wash';
      if (atcPriceEl) atcPriceEl.textContent = v.price;
    }

    sizes.forEach(function (btn) {
      btn.addEventListener('click', function () {
        sizes.forEach(function (x) { x.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var variantId = btn.getAttribute('data-variant-id');
        var form = btn.closest('form');
        if (form) {
          var input = form.querySelector('input[name="id"]');
          if (input) input.value = variantId;
        }
        updateUi(variantId);
      });
    });
  });
})();

/* ─── PDP FAQ accordion ─── */
(function () {
  document.querySelectorAll('[data-pdp-faq]').forEach(function (list) {
    var items = list.querySelectorAll('[data-pdp-faq-item]');
    // Open first on mobile
    if (window.innerWidth < 768 && items[0]) items[0].classList.add('is-open');
    items.forEach(function (item) {
      var btn = item.querySelector('[data-pdp-faq-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        items.forEach(function (x) { x.classList.remove('is-open'); });
        if (!isOpen) item.classList.add('is-open');
      });
    });
  });
})();

/* ─── Cart drawer ─────────────────────────────────────────────── */
(function () {
  // Robust: handlers attach globally, drawer is looked up at handler-call time
  // so it works whether or not the section rendered on a particular template.
  function getDrawer() { return document.querySelector('[data-cart-drawer]'); }
  function getBody() { var d = getDrawer(); return d ? d.querySelector('[data-cart-body]') : null; }
  function getFooter() { var d = getDrawer(); return d ? d.querySelector('[data-cart-footer]') : null; }

  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      if (parseInt(n, 10) > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  }
  function open() {
    var drawer = getDrawer();
    if (!drawer) { window.location.href = '/cart'; return; }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
  }
  function close() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
  }
  window.WoshCart = { open: open, close: close };
  document.addEventListener('wosh:cart:open', open);

  // Triggers — drawer opens from [data-cart-drawer-trigger] OR any link to /cart
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-cart-drawer-trigger]');
    if (!trigger) {
      var link = e.target.closest('a');
      if (link) {
        var href = link.getAttribute('href') || '';
        // Match /cart, /cart/, /cart?..., /en/cart, etc.
        if (/(^|\/)cart\/?($|\?|#)/.test(href)) trigger = link;
      }
    }
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      open();
      refresh();
      return;
    }
    if (e.target.closest('[data-cart-close]')) {
      e.preventDefault();
      close();
    }
  }, true); // capture phase — beats any other inner listeners

  document.addEventListener('keydown', function (e) {
    var drawer = getDrawer();
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) close();
  });

  // Sync auto-gifts (free 1L per 5L/10L) then re-render — keeps gift qty and the
  // final price in sync in real time, no manual refresh needed.
  // Exposed for custom add-to-cart flows (e.g. the PDP bundle/gift builder).
  window.woshOpenCart = open;
  window.woshCartRefresh = function () { return syncThenRefresh(); };

  function syncThenRefresh() {
    var s = (typeof window.woshSyncGifts === 'function') ? window.woshSyncGifts() : null;
    return Promise.resolve(s).then(function () { return refresh(); });
  }

  // Fetch latest cart and re-render body + footer using Section Rendering API
  function refresh() {
    return fetch('/?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data['cart-drawer']) return;
        var parser = new DOMParser();
        var doc = parser.parseFromString(data['cart-drawer'], 'text/html');
        var newBody = doc.querySelector('[data-cart-body]');
        var newFooter = doc.querySelector('[data-cart-footer]');
        var body = getBody();
        var footer = getFooter();
        if (newBody && body) body.innerHTML = newBody.innerHTML;
        if (newFooter && footer) footer.innerHTML = newFooter.innerHTML;
        var newCount = doc.querySelector('[data-cart-count]');
        if (newCount) setCount(newCount.textContent.trim());
      })
      .catch(function () { /* no-op */ });
  }

  // AJAX add-to-cart for any form posting to /cart/add (PDP, upsell, anywhere)
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('form');
    if (!form) return;
    const action = (form.getAttribute('action') || '').toString();
    const isAddForm = form.hasAttribute('data-cart-add-form') || /\/cart\/add(\b|$|\?)/.test(action);
    if (!isAddForm) return;
    e.preventDefault();
    const fd = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function () { open(); return syncThenRefresh(); })
      .catch(function () { /* fail silently */ });
  });

  // Quantity buttons
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-cart-qty]');
    if (!btn) return;
    e.preventDefault();
    const line = parseInt(btn.getAttribute('data-line'), 10);
    const direction = btn.getAttribute('data-cart-qty');
    const numEl = btn.parentElement.querySelector('.wosh-cart-drawer__qty-num');
    let qty = parseInt(numEl ? numEl.textContent.trim() : '1', 10);
    qty = direction === 'increase' ? qty + 1 : Math.max(0, qty - 1);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty }),
    })
      .then(function (r) { return r.json(); })
      .then(function () { return syncThenRefresh(); });
  });

  // Remove links (use href as fallback, intercept to AJAX)
  document.addEventListener('click', function (e) {
    const link = e.target.closest('[data-cart-remove]');
    if (!link) return;
    e.preventDefault();
    const url = link.getAttribute('href');
    if (!url) return;
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function () { return syncThenRefresh(); });
  });

  // After a bundle action: refresh the drawer if clicked there, else reload the page (cart page).
  function afterBundle(el) {
    if (el && el.closest && el.closest('[data-cart-drawer]')) return syncThenRefresh();
    // Cart page: sync the gift first (so the new 1L is added), THEN reload so both show.
    var s = (typeof window.woshSyncGifts === 'function') ? window.woshSyncGifts() : null;
    return Promise.resolve(s).then(function () { window.location.reload(); });
  }

  // 10L bundle: "+" on a sub adds a STANDARD-priced 5L of that aroma (a normal line).
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest && e.target.closest('[data-bundle-add]');
    if (!addBtn) return;
    e.preventDefault();
    var vid = parseInt(addBtn.getAttribute('data-bundle-add'), 10);
    if (!vid) return;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] }) })
      .then(function () { return afterBundle(addBtn); });
  });

  // 10L bundle: remove the whole bundle (all lines sharing the _bundle id).
  document.addEventListener('click', function (e) {
    var rm = e.target.closest && e.target.closest('[data-remove-bundle]');
    if (!rm) return;
    e.preventDefault();
    var bid = rm.getAttribute('data-remove-bundle');
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var keys = (cart.items || []).filter(function (it) { return it.properties && it.properties._bundle === bid; }).map(function (it) { return it.key; });
        var chain = Promise.resolve();
        keys.forEach(function (k) { chain = chain.then(function () { return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: k, quantity: 0 }) }); }); });
        return chain.then(function () { return afterBundle(rm); });
      });
  });
})();

/* ─── Cart PAGE qty/remove: apply change, sync the gift, then reload so the
   free 1L updates in real time (the page's plain reload links add the gift only
   after render, which looked like it needed a second refresh). ─── */
(function () {
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var a = e.target.closest('.wosh-cart__qty-btn, .wosh-cart__remove');
    if (!a) return;
    var href = a.getAttribute('href');
    if (!href) return; // bundle remove is a <button> (handled elsewhere)
    e.preventDefault();
    fetch(href, { headers: { 'Accept': 'application/json' } })
      .then(function () { return (typeof window.woshSyncGifts === 'function') ? window.woshSyncGifts() : null; })
      .then(function () { window.location.reload(); })
      .catch(function () { window.location.href = href; });
  });
})();

/* ─── Collection filters — AJAX in place (no scroll-to-top) ─── */
(function () {
  var grid = document.querySelector('.wosh-coll-grid');
  var filterBar = document.querySelector('.wosh-coll-filters');
  if (!grid || !filterBar) return;

  function navigate(url) {
    filterBar.classList.add('is-loading');
    fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('.wosh-coll-grid');
        var newBar = doc.querySelector('.wosh-coll-filters');
        if (newGrid) grid.innerHTML = newGrid.innerHTML;
        if (newBar) filterBar.innerHTML = newBar.innerHTML;
        window.history.pushState({}, '', url);
      })
      .catch(function () { window.location.href = url; })
      .finally(function () { filterBar.classList.remove('is-loading'); });
  }

  filterBar.addEventListener('click', function (e) {
    var link = e.target.closest('.wosh-coll-filter');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href) return;
    e.preventDefault();
    navigate(href);
  });

  window.addEventListener('popstate', function () {
    navigate(window.location.href);
  });
})();
